import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const booksApi = createApi({
  reducerPath: 'booksApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['Book'],
  refetchOnMountOrArgChange: 1,
  endpoints: (builder) => ({

    // get all book covers on categories
    getAllBooks: builder.query({
      query: (data) => {
        return {
          url: `books?page=${data.page}&size=${data.size}&searchid=${data.searchid}&lang=${data.lang}&status=${data.status}`,
          method: 'GET',
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['Book'],
    }),


    getAllSearchBook: builder.query({
      query: (data) => {
        return {
          url: `search/${data.name}?page=${data.page}&size=${data.size}`,
          method: 'GET',
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['Book'],
    }),


    // create books on covers
    createCover: builder.mutation({
      query: (data) => {
        return {
          url: `books`,
          method: 'POST',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Book'],
    }),
    // update boo cover
    updateBookCover: builder.mutation({
      query: (data) => { 
        return {
          url: `books/${data.id}`,
          method: 'PUT',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Book'],
    }),

    // create book item
    createBookItem: builder.mutation({
      query: (data) => { 
        return {
          url: `book_items/${data.book_id}/${data.languageCode}`,
          method: 'POST',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Book'],
    }),


    updateBookItem: builder.mutation({
      query: (data) => { 
        return {
          url: `book_items/${data.id}`,
          method: 'PUT',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Book'],
    }),

    deleteBook: builder.mutation({
      query: (data) => {
        return {
          url: `books/${data.id}`,
          method: 'DELETE',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['Book'],
    }),


  }),
})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
  useGetAllBooksQuery,
  useGetAllSearchBookQuery,
  useCreateCoverMutation,
  useUpdateBookCoverMutation,
  useCreateBookItemMutation,
  useUpdateBookItemMutation,
  useDeleteBookMutation
} = booksApi